import { FunctionComponent, HTMLAttributes, ReactNode, MouseEvent } from "react";
import styles from "./Dropdown.module.css";
import NavigationLink from "components/navigation/NavigationLink";

interface DropdownItemProps extends HTMLAttributes<HTMLSpanElement>{
  href?: string;
  icon?: ReactNode;
  iconAlwaysVisible?: boolean;
  onIconClick?: (e: MouseEvent<HTMLSpanElement>) => void;
}

/** A component that represents an item in a dropdown menu. */
const Item: FunctionComponent<DropdownItemProps> = ({
  children,
  href,
  icon,
  iconAlwaysVisible = false,
  onIconClick,
  ...props
}) => {
  const handleIconClick = (e: MouseEvent<HTMLSpanElement>) => {
    e.preventDefault();
    e.stopPropagation();
    if (onIconClick) {
      onIconClick(e);
    }
  };

  const iconClassName = iconAlwaysVisible
    ? `${styles.dropdownItemIcon} ${styles.iconAlwaysVisible}`
    : styles.dropdownItemIcon;

  const content = (
    <span className={styles.dropdownItem} {...props}>
      <span className={styles.dropdownItemText}>{children}</span>
      {icon && (
        <span
          className={iconClassName}
          onClick={handleIconClick}
        >
          {icon}
        </span>
      )}
    </span>
  );

  return href ? (
    <NavigationLink className={styles.dropdownItemLink} to={href}>
      {content}
    </NavigationLink>
  ) : content;
};

export default Item;
